import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import EmployeeForm from "./EmployeeForm";
import IconButton from "../common/IconButton";
import React, {Fragment, useState} from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import {FormProvider, useForm} from "react-hook-form";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {selectLang, Translate} from "../../app/store/reducers/main/mainReducer";
import {addEmployeeAsync} from "../../app/store/reducers/employee/employeeReducer";

const AddEmployeeModal = ({noName}) => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const methods = useForm({
        defaultValues: {
            name: "",
        },
    });

    const handleShow = () => setShow(true);
    const handleClose = () => {
        methods.reset();
        setShow(false);
    };

    const onSubmit = formData => {
        setLoading(true);

        addEmployeeAsync({name: formData.name})
            .then(() => {
                toast.success(t(lang, 'employee.add_employee_modal.toast.success'));
                handleClose();
            })
            .catch(() => toast.error(t(lang, 'employee.add_employee_modal.toast.error')))
            .finally(() => setLoading(false))
    };

    return (
        <Fragment>
            <IconButton variant={'falcon-primary'} icon={'plus'} onClick={handleShow}>
                {!noName && t(lang, 'main.common.add')}
            </IconButton>

            <Modal size={'md'} show={show} onHide={handleClose}>
                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Modal.Header closeButton={true}>
                            <Modal.Title>{t(lang, 'employee.add_employee_modal.title')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <EmployeeForm/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant={'secondary'} onClick={handleClose}>{t(lang, 'main.common.back')}</Button>
                            <Button variant={'primary'} type={'submit'} disabled={loading}>
                                {loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                                {t(lang, 'main.common.add')}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </FormProvider>
            </Modal>
        </Fragment>
    );
};

export default AddEmployeeModal;